import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	more: {
		id: 'navigation-apps-sidebar-nav4-sidebar-content.configurable-menu-items.sidebar-customization.more',
		defaultMessage: 'More',
		description: 'Message for more nav menu item in the sidebar',
	},
});
